export var Routes = {
    HOMEPAGE: '/',
    CART: '/sepetim',
    DELIVERY_ADDRESS: '/teslimat-adresi'
};
